import { useEffect, useState } from "react"
import { AFSClassification, SocialAccountMapping, PPTClassification, PPTRules, PPTRulesAFSClassifications, PPTRulesCategorisation, PPTRulesClassifications, PPTRulesDescriptionCategorisations, PPTRulesReconciliations, Reconciliation, UpdatePPTRulesDescriptionCategorisationRequest } from "../../helpers/interfaces"
import { FormEditMode, ReportType } from "../../helpers/constants"

import CustomDialog from "../CustomDialog"
import { Autocomplete, Button, Checkbox, Paper, TextField } from "@mui/material"
import { Add } from "@mui/icons-material"

import { getAllPPTRules, updatePPTRules } from "../../apiServices/PPTRulesApi"


interface Props {
    reportType: ReportType
    setPPTRules: React.Dispatch<React.SetStateAction<PPTRules[]>>
    pptRules: PPTRules[]
    pptClassification: PPTClassification[]
    reconciliation: Reconciliation[]
    afsClassification: AFSClassification[]
    openOpexRulesForm: boolean
    setFormEditMode: React.Dispatch<React.SetStateAction<number>>
    setOpenOpexRulesForm: React.Dispatch<React.SetStateAction<boolean>>
    opexRuleToEdit: string
    opexRuleEditMode: number
    pptCategorizations: PPTRulesCategorisation[]
    year: string
    socialAccountMapping: SocialAccountMapping[]
}

function CreateEditOpexRules({ socialAccountMapping, pptCategorizations, year, opexRuleEditMode, setPPTRules, pptRules, pptClassification, reconciliation, afsClassification, openOpexRulesForm, reportType, setOpenOpexRulesForm, opexRuleToEdit }: Props) {
    const [descriptionName, setDescriptionName] = useState<string>("");
    const [descriptionCategorisation, setDescriptionCategorisation] = useState<PPTRulesDescriptionCategorisations[]>([]);


    useEffect(() => {
        if (opexRuleEditMode === FormEditMode.EDIT) {
            var pptRule = pptRules.find(a => a.pptRulesDescriptionId === opexRuleToEdit)
            if (!pptRule) return
            setDescriptionName(pptRule.pptRulesDescription?.name)
            setDescriptionCategorisation(pptRule.pptRulesDescriptionCategorisations)
        }
    }, [opexRuleEditMode, opexRuleToEdit, pptRules])

    const handleisManualInputCheck = (item: PPTRulesDescriptionCategorisations) => {
        // Find the target item
        const targetItem = descriptionCategorisation.find(a => a.pptRulesCategorisationId === item.pptRulesCategorisationId);

        if (!targetItem) return; // Exit early if item is not found

        // Update the `isManualInput` state for the target item
        const updatedIsManualInput = !targetItem.isManualInput;
        //setIsChecked(updatedIsManualInput);

        // Create a new array with the updated item
        const updatedDescriptionCategorisation = descriptionCategorisation.map(e =>
            e.pptRulesCategorisationId === targetItem.pptRulesCategorisationId
                ? { ...e, isManualInput: updatedIsManualInput }
                : e
        );

        // Update the state
        setDescriptionCategorisation(updatedDescriptionCategorisation);
    };

    const handleisNegativeInputCheck = (item: PPTRulesDescriptionCategorisations) => {
        // Find the target item
        const targetItem = descriptionCategorisation.find(a => a.pptRulesCategorisationId === item.pptRulesCategorisationId);

        if (!targetItem) return; // Exit early if item is not found

        // Update the `isNegateValue` state for the target item
        const updatedIsNegateValue = !targetItem.isNegateValue;


        // Create a new array with the updated item
        const updatedDescriptionCategorisation = descriptionCategorisation.map(e =>
            e.pptRulesCategorisationId === targetItem.pptRulesCategorisationId
                ? { ...e, isNegateValue: updatedIsNegateValue }
                : e
        );

        // Update the state
        setDescriptionCategorisation(updatedDescriptionCategorisation);
    };
    function UpdatePPTRules() {
        const pptrulesData: UpdatePPTRulesDescriptionCategorisationRequest[] = descriptionCategorisation.map(e => {
            return {
                pptRulesCategorisationId: e.pptRulesCategorisationId,
                isManualInput: e.isManualInput,
                isNegateValue: e.isNegateValue,
                socialAccountMappingIds: e.pptRulesSocialAccountMappings.map(e => e.socialAccountMappingId),
                pptClassificationIds: e.pptRulesClassifications.map(e => e.pptClassificationId),
                reconciliationIds: e.pptRulesReconciliations.map(e => e.reconciliationId),
                afsClassificationIds: e.pptRulesAFSClassifications.map(e => e.afsClassificationId),
                pptRulesId: e.pptRulesId,
                pptRulesDescriptionCategorisationId: e.id
            }
        })
        updatePPTRules(pptrulesData).then((pptrule) => {
            getAllPPTRules(reportType, year).then(pptRules => setPPTRules(pptRules.sort((a, b) => a.pptRulesDescription.order - b.pptRulesDescription.order)))

        });
        setOpenOpexRulesForm(false)
    }


    const handleUpdateClassificationFieldValue = (item: PPTRulesDescriptionCategorisations, value: string[]) => {
        // Find the target item
        const targetItem = descriptionCategorisation.find(a => a.pptRulesCategorisationId === item.pptRulesCategorisationId);

        if (!targetItem) return; // Exit early if item is not found

        var _pptRulesClassification = value.map(e => {
            const classifications: PPTRulesClassifications = {
                pptClassificationId: e,
                pptRulesDescriptionCategorisationId: null,
                pptClassification: null
            }
            return classifications
        })
        //var pptRulesClassification = [...item.pptRulesClassifications,..._pptRulesClassification]
        // Create a new array with the updated item
        const updatedDescriptionCategorisation = descriptionCategorisation.map(e =>
            e.pptRulesCategorisationId === targetItem.pptRulesCategorisationId
                ? { ...e, pptRulesClassifications: _pptRulesClassification }
                : e
        );

        // Update the state
        setDescriptionCategorisation(updatedDescriptionCategorisation);
    };

    const handleUpdateAFSClassificationFieldValue = (item: PPTRulesDescriptionCategorisations, value: string[]) => {
        // Find the target item
        const targetItem = descriptionCategorisation.find(a => a.pptRulesCategorisationId === item.pptRulesCategorisationId);

        if (!targetItem) return; // Exit early if item is not found

        var _pptRulesAFSClassification = value.map(e => {
            const classifications: PPTRulesAFSClassifications = {
                afsClassificationId: e,
                pptRulesDescriptionCategorisationId: null,
                afsClassification: null
            }
            return classifications
        })
        //var pptRulesClassification = [...item.pptRulesClassifications,..._pptRulesClassification]
        // Create a new array with the updated item
        const updatedDescriptionCategorisation = descriptionCategorisation.map(e =>
            e.pptRulesCategorisationId === targetItem.pptRulesCategorisationId
                ? { ...e, pptRulesAFSClassifications: _pptRulesAFSClassification }
                : e
        );

        // Update the state
        setDescriptionCategorisation(updatedDescriptionCategorisation);
    };
//     const handleUpdateSocialAccountMappingFieldValue = (
//   item: PPTRulesDescriptionCategorisations,
//   value: string[]
// ) => {
//   const targetItem = descriptionCategorisation.find(
//     a => a.pptRulesCategorisationId === item.pptRulesCategorisationId
//   );
 
//   if (!targetItem) return;
 
//   // Remove duplicates by using a Set
//   const uniqueValues = Array.from(new Set(value));
 
//   const _pptRulesSocialAccountMapping = uniqueValues.map(e => {
//     const classifications: PPTRulesSocialAccountMappings = {
//       socialAccountMappingId: e,
//       pptRulesDescriptionCategorisationId: null,
//       socialAccountMapping: null
//     };
//     return classifications;
//   });
 
//   const updatedDescriptionCategorisation = descriptionCategorisation.map(e =>
//     e.pptRulesCategorisationId === targetItem.pptRulesCategorisationId
//       ? { ...e, pptRulesSocialAccountMappings: _pptRulesSocialAccountMapping }
//       : e
//   );
 
//   setDescriptionCategorisation(updatedDescriptionCategorisation);
// };
   /*  const handleUpdateSocialAccountMappingFieldValue = (item: PPTRulesDescriptionCategorisations, value: string[]) => {
        // Find the target item
        const targetItem = descriptionCategorisation.find(a => a.pptRulesCategorisationId === item.pptRulesCategorisationId);

        if (!targetItem) return; // Exit early if item is not found

        var _pptRulesSocialAccountMapping = value.map(e => {
            const classifications: PPTRulesSocialAccountMappings = {
                socialAccountMappingId: e,
                pptRulesDescriptionCategorisationId: null,
                socialAccountMapping: null
            }
            return classifications
        })
        //var pptRulesClassification = [...item.pptRulesClassifications,..._pptRulesClassification]
        // Create a new array with the updated item
        const updatedDescriptionCategorisation = descriptionCategorisation.map(e =>
            e.pptRulesCategorisationId === targetItem.pptRulesCategorisationId
                ? { ...e, pptRulesSocialAccountMappings: _pptRulesSocialAccountMapping }
                : e
        );

        // Update the state
        setDescriptionCategorisation(updatedDescriptionCategorisation);
    }; */

    const handleUpdateReconciliationFieldValue = (item: PPTRulesDescriptionCategorisations, value: string[]) => {
        // Find the target item
        const targetItem = descriptionCategorisation.find(a => a.pptRulesCategorisationId === item.pptRulesCategorisationId);

        if (!targetItem) return; // Exit early if item is not found

        var _pptRulesReconciliation = value.map(e => {
            const reconciliation: PPTRulesReconciliations = {
                pptRulesDescriptionCategorisationId: null,
                reconciliationId: e,
                reconciliation: null
            }
            return reconciliation
        })
        //var pptRulesReconciliation = [...item.pptRulesReconciliations,..._pptRulesReconciliation]
        // Create a new array with the updated item
        const updatedDescriptionCategorisation = descriptionCategorisation.map(e =>
            e.pptRulesCategorisationId === targetItem.pptRulesCategorisationId
                ? { ...e, pptRulesReconciliations: _pptRulesReconciliation }
                : e
        );

        // Update the state
        setDescriptionCategorisation(updatedDescriptionCategorisation);
    };

    return (

        <>
            <CustomDialog dialogTitle={descriptionName} setOpenDialog={setOpenOpexRulesForm} openDialog={openOpexRulesForm}>
                <form>
                    <div className="grid grid-cols-2 gap-4">
                        {descriptionCategorisation.map((item, index) => {
                            return (
                                <div key={index} >

                                    <fieldset className='' style={{ border: '1px solid #b9b9b9' }}>
                                        <legend className='sectionTitle'><Paper className='font-semibold' sx={{ padding: '5px' }}>{pptCategorizations.sort((a, b) => a.order - b.order).find(a => a.id === item.pptRulesCategorisationId)?.name}</Paper></legend>
                                        <div style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                                            <div className=" flex flex-row ">
                                                {item.isManualInput === false &&
                                                    <>
                                                        <div >

                                                            <div id="isnegative" style={{ fontSize: '12px' }}><Checkbox color='secondary' size="small" value='true' checked={item.isNegateValue} onChange={(e) => { handleisNegativeInputCheck(item) }} />Negate Value</div>
                                                        </div>
                                                    </>
                                                }
                                                <div style={{ flexGrow: 1 }} />
                                                <div >

                                                    <div id="manual_Input" style={{ fontSize: '12px' }}><Checkbox color='secondary' size="small" value='true' checked={item.isManualInput} onChange={(e) => { handleisManualInputCheck(item) }} />Manual Input</div>
                                                </div>
                                            </div>

                                            {(item.isManualInput === false && descriptionName !== 'COSTS PER AUDITED FINANCIAL STATEMENT') ? <>
                                                <div style={{ width: '100%', margin: '0px !important' }}>
                                                    <div >
                                                        <label style={{ fontSize: '12px' }} className='font-medium'>PPT Classification<span className='important'>*</span></label>
                                                    </div>
                                                    <Autocomplete ChipProps={{ color: 'error', size: 'small' }}
                                                        id="pptClassification"
                                                        options={pptClassification} // Pass the full array of objects
                                                        autoSelect
                                                        multiple
                                                        size="small"
                                                        value={item.pptRulesClassifications
                                                            .map(e => pptClassification.find(opt => opt.id === e.pptClassificationId))
                                                            .filter(Boolean) // Remove any undefined values
                                                        }
                                                        onChange={(e, newValue) => {
                                                            const updatedValues = newValue.map(option => option?.id || ""); // Safely extract the IDs
                                                            handleUpdateClassificationFieldValue(item, updatedValues);
                                                        }}
                                                        getOptionLabel={(option) => (option ? option.name : "")} // Handle undefined option
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                placeholder="Select PPT Classification"
                                                                margin="none"
                                                                variant="outlined"
                                                                size="small"
                                                            />
                                                        )}
                                                    />


                                                </div>
                                                <br />
                                                <div style={{ width: '100%', margin: '0px !important' }}>
                                                    <div >
                                                        <label style={{ fontSize: '12px' }} className='font-medium'>Reconciliation<span className='important'>*</span></label>
                                                    </div>
                                                    <Autocomplete ChipProps={{ color: 'error', size: 'small' }} id="reconciliation" options={reconciliation} autoSelect multiple size="small"

                                                        value={item.pptRulesReconciliations
                                                            .map((e: { reconciliationId: string }) => reconciliation.find(opt => opt.id === e.reconciliationId))
                                                            .filter(Boolean) // Remove any undefined values
                                                        }

                                                        onChange={(e, newValue) => {
                                                            const updatedValues = newValue.map(option => option?.id || ""); // Safely extract the IDs
                                                            handleUpdateReconciliationFieldValue(item, updatedValues);
                                                        }}
                                                        getOptionLabel={(option) => (option ? option.name : "")}
                                                        renderInput={(params) => (<TextField {...params} placeholder='Select Reconciliation' margin="none" variant="outlined" size='small' />)}
                                                    />
                                                </div>
                                                <br />
                                            </> : ''
                                            }
                                            {(item.isManualInput === false && descriptionName === 'COSTS PER AUDITED FINANCIAL STATEMENT') ?
                                                <>
                                                
                                                <div style={{ width: '100%', margin: '0px !important' }}>
                                                    <div >
                                                        <label style={{ fontSize: '12px' }} className='font-medium'>AFS Classification<span className='important'>*</span></label>
                                                    </div>
                                                    <Autocomplete ChipProps={{ color: 'error', size: 'small' }}
                                                        id="afsClassification"
                                                        options={afsClassification} // Pass the full array of objects
                                                        autoSelect
                                                        multiple
                                                        size="small"
                                                        value={item.pptRulesAFSClassifications?.map(e => afsClassification?.find(opt => opt.id === e.afsClassificationId))
                                                            .filter(Boolean) // Remove any undefined values
                                                        }
                                                        onChange={(e, newValue) => {
                                                            const updatedValues = newValue.map(option => option?.id || ""); // Safely extract the IDs
                                                            handleUpdateAFSClassificationFieldValue(item, updatedValues);
                                                        }}
                                                        getOptionLabel={(option) => (option ? option.name : "")} // Handle undefined option
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                placeholder="Select AFS Classification"
                                                                margin="none"
                                                                variant="outlined"
                                                                size="small"
                                                            />
                                                        )}
                                                    />

                                                </div>
                                                <br/>
                                                    {/* <div style={{ width: '100%', margin: '0px !important' }}>
                                                        <div >
                                                            <label style={{ fontSize: '12px' }} className='font-medium'>Social Account Mapping<span className='important'>*</span></label>
                                                        </div>
                                                        <Autocomplete ChipProps={{ color: 'error', size: 'small' }}
                                                            id="socialAccountMapping"
                                                            options={socialAccountMapping} // Pass the full array of objects
                                                            autoSelect
                                                            multiple
                                                            size="small"
                                                            value={item.pptRulesSocialAccountMappings
                                                                .map(e => socialAccountMapping.find(opt => opt.id === e.socialAccountMappingId))
                                                                .filter(Boolean) // Remove any undefined values
                                                            }
                                                            onChange={(e, newValue) => {
                                                                const updatedValues = newValue.map(option => option?.id || ""); // Safely extract the IDs
                                                                handleUpdateSocialAccountMappingFieldValue(item, updatedValues);
                                                            }}
                                                            getOptionLabel={(option) => (option ? option.name : "")} // Handle undefined option
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    placeholder="Select Social Account Mapping"
                                                                    margin="none"
                                                                    variant="outlined"
                                                                    size="small"
                                                                />
                                                            )}
                                                        />


                                                    </div> */}
                                                </>
                                                : ''

                                            }

                                        </div>
                                        <br />
                                    </fieldset>
                                </div>
                            )
                        })}


                    </div>
                    <div className="form-group mt-3 mb-5" style={{ float: 'right' }}>
                        <Button variant="contained" color='secondary' onClick={UpdatePPTRules} ><Add />&nbsp; Update PPT Rules </Button>
                    </div>
                    <br />
                </form >


            </CustomDialog>

        </>
    )
}
export default CreateEditOpexRules